import AjaxHandler from "./ajax-handler";
import "select2";
import { md5 } from "hash-wasm";
import { debounce } from "throttle-debounce";

class ProductCategoryFilter {
	constructor() {
		this.$ = jQuery;
		this.ajax = new AjaxHandler();
		this.filterRequest = false;
		this.filterParams = new URLSearchParams(window.location.search);

		if ($(".product-category-filter").length) {
			this.form = $(
				'.product-category-filter form[name="filter-category-products"]'
			);

			this.formContainer = this.form.closest(".filter-form-container");

			this.initFilters();
		}

		this.initLoadMore();
	}

	isInViewport(element) {
		const rect = element.getBoundingClientRect();

		var extra_space = $(element).outerHeight();

		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <=
				(window.innerHeight || document.documentElement.clientHeight) +
					extra_space &&
			rect.right <=
				(window.innerWidth || document.documentElement.clientWidth)
		);
	}

	stickyScroll() {
		var self = this;

		var $productFilter = $(".product-filter");

		var sticky = new Waypoint.Sticky({
			element: $productFilter[0],
			wrapper: false
		});

		$(window).on("resize scroll", function() {
			var $extraBlocks = $("#archive-extra-blocks");
			var $footer = $(".site-footer").find("container");

			var $filterTabs = $productFilter.find(
				"> #product-category-filter-tabs"
			);

			var footerHeight = $(".site-footer").outerHeight();
			var extraBlockheights =
				$("#archive-extra-blocks").outerHeight() + 140; // 48*48 in padding + extra space
			var hHeight = $("header.site-header").outerHeight();

			if ($(window).width() > 768) {
				if ($productFilter.hasClass("stuck")) {
					$filterTabs.css("top", hHeight);
				}

				if (
					$extraBlocks.is(":in-viewport") ||
					$footer.is(":in-viewport")
				) {
					$filterTabs.removeClass("bottom").addClass("bottom");
					$filterTabs.css(
						"bottom",
						footerHeight + extraBlockheights + "px"
					);
				} else {
					$filterTabs.removeClass("bottom");
					$filterTabs.css("bottom", 0);
				}
			} else {
				$filterTabs.css("top", 0);
			}
		});
	}

	refreshSelectedFilters() {
		var self = this;

		// Boxes
		var $displayedHtml = $(
			".filter-container .filter-marks .selections .marks, .product-category-filter .filter-marks .selections .marks, .filter-marks .selections .marks"
		);
		var $all_checked = $(
			'#filter-selects .accordion-item input[type="checkbox"].filter-option'
		).filter(":checked");

		const $clearFilterBtn = $(".filter-container .clear-filter, .product-category-filter .clear-filter, .filter-marks .clear-filter");

		if ($displayedHtml.length) {
			//$displayedHtml.empty();
			// Keep clear flter button
			$displayedHtml.find("a").each(function() {
				if (!$(this).hasClass("clear-filter")) {
					$(this).remove();
				}
			});

			for (const checkbox of $all_checked) {
				var $ch = $(checkbox);

				var $elem = `
					<a href="#" data-id="${$ch.attr(
						"id"
					)}" class="mr-1 mb-2 btn-filter-toggle  fw-bold no-arrow btn bg-ice-light text-gray-1">
							<span class="me-1">${$ch.next().text()}</span>

							<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M0.683491 0.838713L0.756282 0.756282C1.07171 0.440858 1.56803 0.416595 1.91129 0.683491L1.99372 0.756282L7.5 6.26188L13.0063 0.756282C13.348 0.414573 13.902 0.414573 14.2437 0.756282C14.5854 1.09799 14.5854 1.65201 14.2437 1.99372L8.73812 7.5L14.2437 13.0063C14.5591 13.3217 14.5834 13.818 14.3165 14.1613L14.2437 14.2437C13.9283 14.5591 13.432 14.5834 13.0887 14.3165L13.0063 14.2437L7.5 8.73812L1.99372 14.2437C1.65201 14.5854 1.09799 14.5854 0.756282 14.2437C0.414573 13.902 0.414573 13.348 0.756282 13.0063L6.26188 7.5L0.756282 1.99372C0.440858 1.67829 0.416595 1.18197 0.683491 0.838713L0.756282 0.756282L0.683491 0.838713Z" fill="#000000"/>
							</svg>
					</a>`;

				$displayedHtml.prepend($elem);
			}
		}

		// Filter?
		var _isValid = $all_checked.length;

		if (_isValid) {
			$clearFilterBtn
				.fadeIn()
				.removeClass("d-none")
				.addClass("d-inline-block");

			$clearFilterBtn
				.find(".count")
				.html("(" + $all_checked.length + ")");
		} else {
			$clearFilterBtn
				.fadeOut()
				.removeClass("d-inline-block")
				.addClass("d-none");

			$clearFilterBtn.find(".count").empty();

			self.filterParams.delete("filter");
		}
	}

	initFilters() {
		var self = this;

		const $removeFilters = $(
			".product-category-filter > form .remove-filter"
		);

		const $mFilterTitle = $(".product-category-filter .filter-title");
		const $mToggleModal = $(".product-category-filter > a.toggle-filter");
		const $mFilterHeading = $(".filter-container .filter-heading, .product-category-filter .filter-heading");
		const $mApplyFilterBtn = $(".filter-container .apply-filter, .product-category-filter .apply-filter");
		const $clearFilterBtn = $(".filter-container .clear-filter, .product-category-filter .clear-filter, .filter-marks .clear-filter");
		const $showMoreItems = $("#filter-selects .accordion-item .show-more");
		const $filterOptions = $(
			"#filter-selects .accordion-item .filter-option"
		);

		// Force reload
		// $(window).on("popstate", function() {
		// 	alert('1')
		// 	$(".archive-products").css("opacity", ".5");
		// 	location.reload(true);
		// });

		// Old CSS fix for mobile
		// DEPRECATED
		// $(document).on("scroll click mousedown mouseup touchstart", function() {
		// 	if ($("body").hasClass("product-filter-open")) {
		// 		var $filter_selects = $("#filter-selects");

		// 		$filter_selects.removeAttr("data-select2-id");

		// 		var h = $(
		// 			'form[name="filter-category-products"]'
		// 		).outerHeight();

		// 		var n1 = $(".filter-heading").outerHeight();
		// 		var n2 = $(".filter-bottom").outerHeight();

		// 		$filter_selects.css("height", h - (n1 + n2) - 90);
		// 	}
		// });

		// Hide modal ( Mobile )
		$mFilterHeading.on("click", function(event) {
			if (!$("body").hasClass("product-filter-open")) return false;

			self.formContainer.fadeOut().removeClass("open");
			$("body").removeClass("product-filter-open");
		});

		$showMoreItems.on("click", function(event) {
			event.preventDefault();

			var $showMore = $(this);
			var readMore = $showMore.data("more");
			var readLess = $showMore.data("less");

			$showMore.toggleClass("toggle");

			if ($showMore.hasClass("toggle")) {
				$showMore.html(readLess);
				$(this)
					.prev()
					.find(".hide-filter")
					.addClass("d-block")
					.fadeIn();
			} else {
				$showMore.html(readMore);
				$(this)
					.prev()
					.find(".hide-filter")
					.removeClass("d-block")
					.fadeOut();
			}
		});

		// Trigger on filter alternative
		$filterOptions.on("change", function(event) {
			event.preventDefault();

			// Update filters
			self.refreshSelectedFilters();

			// On desktop in tabs layout, switch to Products tab if not already active
			if (window.innerWidth >= 768) {
				const $productsTab = $('.product-archive-nav .nav-link[href*="-products"]');
				if ($productsTab.length && !$productsTab.hasClass('active')) {
					$productsTab.click();
				}
			}

			// Run filter
			self.form.trigger("submit");

			var target = $('.filter-container');
			var headerHeight = $('#main-header').height();
			if (target.length)
			{
				var top = target.offset().top;
				$('html,body').animate({scrollTop: top-headerHeight}, 100);
				return false;
			}
		});

		// Remove filters via boxes
		$(document).on("click", ".btn-filter-toggle", function(e) {
			e.preventDefault();

			var id = $(this).data("id");
			var $checkbox = $("#" + id);

			if ($checkbox.length) {
				$checkbox.prop("checked", false).trigger("change");
				$(this).fadeOut();
			}
		});

		// Toggle modal ( Mobile )
		$mToggleModal.on("click", function(e) {
			e.preventDefault();

			self.formContainer.fadeToggle().toggleClass("open");
			$("body").toggleClass("product-filter-open");
		});

		// Clear filter
		$clearFilterBtn.on("click", function(e) {
			e.preventDefault();

			$filterOptions.prop("checked", false);
			self.refreshSelectedFilters();

			self.form.trigger("submit");
		});

		// Save filter ( Mobile )
		$mApplyFilterBtn.on("click", function() {
			self.formContainer.fadeOut().removeClass("open");
			$("body").removeClass("product-filter-open");
			self.form.trigger("submit");
		});

		// Submit form
		const debounceForm = debounce(500, false, formData => {
			self.queryFilter(formData);
		});

		self.form.on("submit", function(e) {
			e.preventDefault();

			var formData = {
				paged: jQuery(this)
					.find('input[name="paged"]')
					.val(),
				category_id: jQuery(this)
					.find('input[name="category_id"]')
					.val(),
				posts_per_page: jQuery(this)
					.find('input[name="posts_per_page"]')
					.val(),
				sys_id: jQuery(this)
					.find('input[name="sys_id"]')
					.val(),
				base_url: jQuery(this)
					.find('input[name="base_url"]')
					.val(),
				filters: jQuery(this)
					.find('#filter-selects input[type="checkbox"]')
					.serializeArray()
			};

			console.log("passing formData: " + formData);

			debounceForm(formData);
		});

		// Add sticky scroll
		//self.stickyScroll();

		// Load initial values
		self.markInitialValues();

		// Refresh active filters
		self.refreshSelectedFilters();
	}

	markInitialValues() {
		var self = this;

		// Exit on undefined or no filters
		if (
			typeof _savedProductFilterQuery === "undefined" ||
			_savedProductFilterQuery === ""
		)
			return;

		console.log("_savedProductFilterQuery :>> ", _savedProductFilterQuery);

		try {
			var data = JSON.parse(_savedProductFilterQuery);

			console.log(data);

			for (const [key, filter] of Object.entries(data["filters"])) {
				var hasFilter = false;

				if (filter.name !== undefined && filter.value !== undefined) {
					var $elem = $(
						'input[type="checkbox"].filter-option[name="' +
							filter.name +
							'"][value="' +
							filter.value +
							'"]'
					);

					if ($elem.length) {
						$elem.prop("checked", true);
						hasFilter = true;
					}
				}
			}

			// Trigger form
			// if (hasFilter) {
			// 	self.form.trigger("submit");
			// }
		} catch (e) {
			console.log(e);
		}
	}

	displayFilterCounts() {
		this.filterSelects.each(function(e) {
			let $filterCountTitle = $(this)
				.closest(".filter-block")
				.find(".filter-title");
			let count = $(this).find(":selected").length;

			if (count >= 1) {
				if (!$filterCountTitle.hasClass("active"))
					$filterCountTitle.addClass("active");

				$filterCountTitle
					.find(".filter-count")
					.text("(" + count + ") ");
			} else {
				$filterCountTitle.removeClass("active");
				$filterCountTitle.find(".filter-count").text("");
			}
		});
	}

	async queryFilter(formData) {
		var self = this;

		// Refresh filters
		self.refreshSelectedFilters();

		// Update URL (Remove pagination)
		var url = window.location.href;
		window.history.pushState(
			"object or string",
			document.title,
			url.replace(/page\/[0-9]+/g, "")
		);

		// Save filter & show clear button
		if (formData.filters) {
			var filterHash = await md5(JSON.stringify(formData));

			//console.log("generating hash: " + filterHash);

			formData.filters.length > 0 &&
				self.filterParams.set("filter", filterHash);

			window.history.replaceState(
				{},
				"",
				`${location.pathname}?${self.filterParams}`
			);

			// if (typeof Storage !== "undefined")
			// 	localStorage.setItem(
			// 		"gpa_filters",
			// 		JSON.stringify(formData.filters)
			// 	);
		}

		let postVars = {
			action: "filter_product_categories",
			nonce: ajax.nonce,
			posts_per_page: formData.posts_per_page,
			paged: formData.paged,
			category_id: formData.category_id,
			sys_id: formData.sys_id,
			savedFilterQuery: self.filterParams.get("filter"),
			filters: formData.filters,
			base_url: formData.base_url
		};

		var $filterContainer = $(".product-container .products-list");
		var $resultsContainer = $(".product-container .title-results");
		var $paginationContainer = $("#products-pagination");

		if (self.filterRequest) {
			self.filterRequest.abort();
		}

		$filterContainer.attr("data-requestRunning", true);

		$filterContainer.LoadingOverlay("show", {
			imageClass: "jquery-loading-overlay-icon",
			image: ajax.templateUrl + "/assets/svg/loading.svg",
			imageResizeFactor: 1,
			zIndex: 800,
			background: "rgba(255, 255, 255, 0.5)"
		});

		$(".products-container .no-results")
			.addClass("d-none")
			.removeClass("d-block");

		self.filterRequest = $.ajax({
			beforeSend: xhr => {
				xhr.setRequestHeader("X-WP-Nonce", ajax.nonce);
			},
			url: ajax.url,
			method: "POST",
			data: postVars,
			dataType: "json"
		}).done(response => {
			var html = "";
			$resultsContainer.find("span").text(0);

			if (response.product_count >= 1) {
				$.each(response.product_html, function(key, data) {
					html += data;
				});

				$resultsContainer.find("span").text(response.product_count);
			} else {
				$(".products-container .no-results")
					.fadeIn()
					.addClass("d-block")
					.removeClass("d-none");
			}

			// Update counts
			// for (const [filter_name, values] of Object.entries(
			// 	response.tabs_filter_array.count
			// )) {
			// 	for (const [title, filter_counts] of Object.entries(
			// 		values
			// 	)) {
			// 		for (const [name, value] of Object.entries(
			// 			filter_counts
			// 		)) {
			// 			$('input[name="' + filter_name + '"][value="' + name + '"]').next().find('.count').text('(' + value + ')');

			// 			console.log('input[name="' + filter_name + '"][value="' + name + '"]');
			// 		}
			// 	}
			// }

			// Pagiation & Request
			$paginationContainer.html(response.pagination_html ?? "");

			$filterContainer.LoadingOverlay("hide");
			this.$(".loadingoverlay").remove();

			$filterContainer
				.attr("data-requestRunning", false)
				.fadeIn()
				.html(html);

			self.filterRequest = false;

			// Update load more button AFTER HTML replacement
			// Re-query pagination container since DOM has changed
			$paginationContainer = $("#products-pagination");
			let $loadMoreBtn = $(".load-more-products");

			// If button was removed and there are more pages, recreate it
			if (!$loadMoreBtn.length && response.max_num_pages && response.max_num_pages > 1) {
				const categoryId = self.form ? self.form.find('input[name="category_id"]').val() : '';
				const sysId = self.form ? self.form.find('input[name="sys_id"]').val() : '';
				const postsPerPage = response.posts_per_page || 6;
				const baseUrl = response.base_url || '';

				const buttonHtml = `
					<div class="container d-md-none">
						<div class="row py-5">
							<div class="col text-center">
								<button class="btn btn-primary load-more-products"
										data-page="1"
										data-max-pages="${response.max_num_pages}"
										data-category-id="${categoryId}"
										data-sys-id="${sysId}"
										data-posts-per-page="${postsPerPage}"
										data-base-url="${baseUrl}">
									${ajax.loadMoreText}
								</button>
							</div>
						</div>
					</div>`;

				// Insert after the parent container of pagination, not inside it
				$paginationContainer.closest('.container').after(buttonHtml);
				$loadMoreBtn = $(".load-more-products");

				// Store original button text
				$loadMoreBtn.data("original-text", ajax.loadMoreText);
			} else if ($loadMoreBtn.length && response.max_num_pages) {
				$loadMoreBtn.data("max-pages", response.max_num_pages);
				$loadMoreBtn.data("page", 1); // Reset to page 1 since we're showing new filtered results

				// Show button if hidden and there are more pages
				if (response.max_num_pages > 1) {
					$loadMoreBtn.closest('.container').show();
				} else {
					$loadMoreBtn.closest('.container').remove();
				}
			}

			// Scroll to product-tabs-column on desktop, accounting for header height
			if (window.innerWidth >= 768) {
				const tabsColumn = document.querySelector('.product-tabs-column');
				if (tabsColumn) {
					const headerHeight = document.querySelector('#main-header')?.offsetHeight || 100;
					const tabsColumnPosition = tabsColumn.getBoundingClientRect().top + window.pageYOffset;
					const offsetPosition = tabsColumnPosition - headerHeight;

					window.scrollTo({
						top: offsetPosition,
						behavior: 'smooth'
					});
				}
			}
		});
	}

	initLoadMore() {
		var self = this;

		// Use event delegation to handle dynamically created buttons
		$(document).on("click", ".load-more-products", function(e) {
			e.preventDefault();

			const $btn = $(this);
			const currentPage = parseInt($btn.data("page"));
			const maxPages = parseInt($btn.data("max-pages"));
			const categoryId = $btn.data("category-id");
			const sysId = $btn.data("sys-id");
			const postsPerPage = $btn.data("posts-per-page");
			const baseUrl = $btn.data("base-url");

			const nextPage = currentPage + 1;

			if (nextPage > maxPages) {
				$btn.closest('.container').remove();
				return;
			}

			// Show loading state
			$btn.prop("disabled", true).text(ajax.loadingText);

			const filterParams = self.filterParams;
			const savedFilterQuery = filterParams.get("filter");

			let postVars = {
				action: "filter_product_categories",
				nonce: ajax.nonce,
				posts_per_page: postsPerPage,
				paged: nextPage,
				category_id: categoryId,
				sys_id: sysId,
				savedFilterQuery: savedFilterQuery,
				filters: self.form ? self.form.find('#filter-selects input[type="checkbox"]').serializeArray() : [],
				base_url: baseUrl
			};

			$.ajax({
				beforeSend: xhr => {
					xhr.setRequestHeader("X-WP-Nonce", ajax.nonce);
				},
				url: ajax.url,
				method: "POST",
				data: postVars,
				dataType: "json"
			}).done(response => {
				if (response.product_count >= 1) {
					let html = "";
					$.each(response.product_html, function(key, data) {
						html += data;
					});

					// Append new products
					$(".products-list").append(html);

					// Update button page and max pages from response
					$btn.data("page", nextPage);

					// Update max pages if provided in response (from filtered results)
					if (response.max_num_pages) {
						$btn.data("max-pages", response.max_num_pages);
					}

					$btn.prop("disabled", false).text($btn.data("original-text") || ajax.loadMoreText);

					// Hide button container if no more pages (use updated maxPages)
					const updatedMaxPages = parseInt($btn.data("max-pages"));
					if (nextPage >= updatedMaxPages) {
						$btn.closest('.container').remove();
					}
				} else {
					$btn.closest('.container').remove();
				}
			}).fail((xhr, status, error) => {
				$btn.prop("disabled", false).text($btn.data("original-text") || ajax.loadMoreText);
			});
		});

		// Store original button text for initially existing buttons
		$(".load-more-products").each(function() {
			if (!$(this).data("original-text")) {
				$(this).data("original-text", $(this).text());
			}
		});
	}
}

export default ProductCategoryFilter;
